"use client";
import React, { useRef } from "react";
import Image from "next/image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Beer from "../../../public/assets/client/beer/medusa.png";
import Beer2 from "../../../public/assets/client/beer/yeti.png";
import Beer3 from "../../../public/assets/client/beer/cg.png";
import Beer4 from "../../../public/assets/client/beer/grag-trader.png";
import Beer5 from "../../../public/assets/client/beer/ub.png";

import Food1 from "../../../public/assets/client/food/capital-foods.png";
import Food2 from "../../../public/assets/client/food/gd-foods.png";
import Food3 from "../../../public/assets/client/food/guruji.png";
import Food4 from "../../../public/assets/client/food/masterchow.png";
import Food5 from "../../../public/assets/client/food/vrb.png";

import Liquor1 from "../../../public/assets/client/liquor/nicoles.jpg";
import Liquor2 from "../../../public/assets/client/liquor/globus.png";
import Liquor3 from "../../../public/assets/client/liquor/nicoles.png";
import Liquor4 from "../../../public/assets/client/liquor/pernod-richard.png";
import Liquor5 from "../../../public/assets/client/liquor/redico.png";

// import Pharma1 from "../../../public/assets/client/pharma/biogenetic.png";
// import Pharma2 from "../../../public/assets/client/pharma/dabur.png";
// import Pharma3 from "../../../public/assets/client/pharma/harmony.png";
// import Pharma4 from "../../../public/assets/client/pharma/luthra.png";
// import Pharma5 from "../../../public/assets/client/pharma/shriji.png";


gsap.registerPlugin(ScrollTrigger);

const clientImages = [
  Beer,
  Beer2,
  Beer3,
  Beer4,
  Beer5,
  Food1,
  Food2,
  Food3,
  Food4,
  Food5,
  Liquor1,
  Liquor2,
  Liquor3,
  Liquor4,
  Liquor5,
  // Pharma1,
  // Pharma2,
  // Pharma3,
  // Pharma4,
  // Pharma5
];

const ClientsMobile = () => {
  const sectionRef = useRef(null);
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 4 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="bg-gradient-to-b from-gray-800 to-[#fbf9f5]  pb-[90px] pt-[60px] !mb-3 xl:hidden overflow-x-hidden block" ref={sectionRef}>
      <div className="container mx-auto">
        <h2 className="title !text-center !mb-5 !text-[#fff]">
          Our <span className="text-[#d42427]"> Clients</span>
        </h2>

        <Slider {...settings}>
          {clientImages.map((img, i) => (
            <div key={i} className="px-3">
              <div className="border border-gray-200 shadow-2xl rounded-lg p-2 bg-white transition-all duration-300 hover:scale-105">
                <Image
                  src={img}
                  alt={`client-${i}`}
                  className=" rounded-lg object-contain"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ClientsMobile;
